module.exports = __webpack_public_path__ + "img/calhoun-ema-logo.3de49c32.jpg";